import { fetchCss, getUrlParam } from "helper";
import { BrowserInfo } from "helper/ingame";
import { get_info } from "./main";
import { toggle_toast } from "./modal";

export const set_param = (data) => ({
  type: "SET_PARAM",
  data,
});

export const set_token = () => {
  return (dispatch) => {
    const param = {
      access_token: getUrlParam("access_token") || "",
      account_id: getUrlParam("account_id") || "",
      region: getUrlParam("region") || "",
      lang: String(getUrlParam("lang")).toLowerCase() || "",
    };

    fetchCss(param.lang, param.region);

    if (!param.access_token) {
      dispatch(toggle_toast(true, "NOT_LOGIN"));
    } else {
      dispatch(set_param(param));
      dispatch(get_info());

      if (BrowserInfo().iPhone || BrowserInfo().iPad || BrowserInfo().ios) {
        document.body.id = "ios";
      }
      if (BrowserInfo().android) {
        document.body.id = "android";
      }
    }
  };
};
